import { Box, Stack, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';

import InformationCircleIcon from 'modules/common/components/Icons/InformationCircleIcon';

export default function HomeOfficeTableHead() {
    return (
        <TableHead>
            <TableRow>
                <TableCell sx={{ pl: 0 }}>EXPENSE</TableCell>
                <TableCell align="right">MONTHLY COST</TableCell>
                <TableCell />
                <TableCell align="right">
                    <Stack direction="row" gap="3px" alignItems="center" justifyContent="flex-end">
                        <Tooltip
                            title={
                                <Stack p={1}>
                                    <Typography variant="subtitle1">Home office multiplier</Typography>
                                    <Typography variant="body2" fontWeight={400}>
                                        How much of your expenses you can be reimbursed for.
                                    </Typography>
                                </Stack>
                            }
                            placement="bottom">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <InformationCircleIcon sx={{ color: 'grey.500' }} fontSize="small" />
                            </Box>
                        </Tooltip>
                        <span>MULTIPLIER</span>
                    </Stack>
                </TableCell>
                <TableCell />
                <TableCell align="right" sx={{ pr: 0 }}>
                    REIMBURSABLE
                </TableCell>
            </TableRow>
        </TableHead>
    );
}
